// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"5532f7ca","156":"33fb6cf5","385":"e17f0286","588":"36b5dff3","787":"cfa2756c"}[chunkId] + ".chunk.js";
};